import { 
    getCategories,
    getCategory,
    saveCategory, 
    updateCategory, 
    deleteCategory } from '@/api/run'
import { 
    SET_CATEGORIES,
    SET_CATEGORY,
} from './mutation-types'
import {
    GET_CATEGORY,
    GET_CATEGORIES,
    SAVE_CATEGORY,
    UPDATE_CATEGORY,
    DELETE_CATEGORY,
} from './action-types'
import { router } from "../main.js"

export default {
    state: {
        all: [],
        activeCategory: {},
    },
    mutations: {
        [SET_CATEGORIES] (state, all) {
            state.all = all
        },
        [SET_CATEGORY] (state, cat) {
            state.activeCategory = cat
        },
    },
    getters: {
        categoryByViewName( state ) {
          return (vn) => {
            return state.all.find(c => c.ViewName === vn);
          }
        }
    },
    actions: {
        [GET_CATEGORIES]: async ({commit}) => {
            // commit(SET_RESOURCES_LOADING, true)
            let resp = []
            try {
                resp = await getCategories()
                commit(SET_CATEGORIES, resp)
            }
            finally {
                // commit(SET_RESOURCES_LOADING, false)
            }
        },
        [GET_CATEGORY]: async ({commit}, id) => {
            let resp = await getCategory(id)
            if (resp.error || !resp.objectId) {
                commit('SET_ERROR', 'The category could not be loaded')
                router.push('/404')
            }
            else {
                commit(SET_CATEGORY, resp)
            }
        },
        [SAVE_CATEGORY]: async ({state, commit}) => {
            //console.log('dispatched SAVE_CATEGORY', state.resource)
            let resp = await saveCategory(state.activeCategory)
            if (resp.error || !resp.objectId) {
                commit('SET_ERROR', resp.error)
            }
            else {
                // commit(SET_CATEGORY_ID, resp.objectId)
                // commit('SET_CATEGORYS_CHANGED')
            }
        },
        [UPDATE_CATEGORY]: async ({state, commit}) => {
            let resp = await updateCategory(state.activeCategory)
            if (resp.error) {
                commit('SET_ERROR', resp.error)
            }
        },
        [DELETE_CATEGORY]: async ({ commit }, id) => {
            //console.log('dispatched DELETE_CATEGORY', id)
            let resp = await deleteCategory(id)
            if (resp.error) {
                commit('SET_ERROR', resp.error)
            }
        },
    }
}